module.exports = __webpack_public_path__ + "img/jonathan-saporta.737274b2.png";